module.exports = __webpack_public_path__ + "img/menu-hover.b1716a24.svg";